/**
 * @fileoverview PUT handler for "/decisioning_studio_agents/:app_group_id/:dsa_id/constraints/:component".
 * Templated upsert — the body is just {period, times} for the targeted
 * component. The dashboard backend generates the underlying comparator,
 * logic, and regime_guardrails entries and forwards to Conman.
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentCacheKeys } from "./constants";
import type {
  PutDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentProps,
  PutDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentResult,
} from "./types";

export const putDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponent = reactQueryMutationAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentCacheKeys,
  ({
    appGroupId,
    dsaId,
    component,
    period,
    times,
  }: PutDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentProps): Promise<PutDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentResult> =>
    fetch(`/decisioning_studio_agents/${appGroupId}/${dsaId}/constraints/${component}`, "PUT", {
      period,
      times,
    })
);
